import {
    WAIT_TO_FIRE_INITIAL_TRACKING,
    READY_TO_FIRE_INITIAL_TRACKING,
} from '../actions/trackingRespActions';

const initialState = {
    initialTrackingFired: false,
    waitToFireInitialTracking: false,
};

function trackingRespReducer(state, action) {
    switch (action.type) {
        case WAIT_TO_FIRE_INITIAL_TRACKING:
            return {
                ...state,
                waitToFireInitialTracking: true,
            };
        case READY_TO_FIRE_INITIAL_TRACKING:
            return {
                ...state,
                waitToFireInitialTracking: false,
            };
    }

    return state || initialState;
}

export default trackingRespReducer;
